angular.module('unergie.main')
.factory('LandscapeElements', () => {
    const LandscapeElements = []

    return {
        LandscapeElements,
    }
})
